import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { strings } from "@/i18n/strings";
import { resolveLang, setLangPref } from "@/lib/prefs";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(resolveLang);
  useEffect(() => {
    const syncLanguage = () => {
      const next = resolveLang();
      document.documentElement.setAttribute("lang", next);
      setLangState(next);
    };
    syncLanguage();
    window.addEventListener("popstate", syncLanguage);
    return () => window.removeEventListener("popstate", syncLanguage);
  }, []);
  const t = useCallback(
    (key, params) => {
      const raw = strings[lang][key] ?? strings.id[key] ?? key;
      return params ? raw.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? "") : raw;
    },
    [lang],
  );
  const setLang = useCallback((l) => {
    if (setLangPref(l)) setLangState(l);
  }, []);
  const value = useMemo(() => ({ lang, t, setLang }), [lang, t, setLang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
